export default __webpack_public_path__ + "static/media/ico-poi-24.cdf3384a.svg";